import { IStateMap, ITestPart } from '@/controllers/session/models/IQtiSession';
import DeliveryOptionsProvider from './DeliveryOptionsProvider';
import Item from './Item';
import Section from './Section';
import TestPart from './TestPart';

class Test extends DeliveryOptionsProvider {
  public static readonly NO_STATE = 0;
  public static readonly SECTION_INSTRUCTIONS_STATE = 1;
  public static readonly SECTION_END_STATE = 2;
  public static readonly TEST_END_STATE = 3;

  private readonly _identifier: string;
  private readonly _title: string;
  private readonly _testParts: Array<TestPart> = new Array<TestPart>();
  private _locationState = Test.NO_STATE;
  private _completed = false;
  constructor(identifier: string, title: string) {
    super();
    this._identifier = identifier;
    this._title = title;
  }

  get identifier(): string {
    return this._identifier;
  }

  get title(): string {
    return this._title;
  }

  get testParts(): Array<TestPart> {
    return this._testParts;
  }

  set locationState(value: number) {
    this._locationState = value;
  }

  get locationState(): number {
    return this._locationState;
  }

  get completed(): boolean {
    return this._completed;
  }

  set completed(value: boolean) {
    this._completed = value;
  }

  getCurrentTestPart(): TestPart {
    if (this.getCurrentItem()) {
      return this.getCurrentItem()!.section.testPart;
    } else {
      return this.testParts[0];
    }
  }

  getIncompleteCount(): number {
    return this.getCount((section: Section) => {
      return section.getIncompleteCount();
    });
  }
  getFlaggedCount(): number {
    return this.getCount((section: Section) => {
      return section.getFlaggedCount();
    });
  }

  addTestPart(testPart: TestPart) {
    this._testParts.push(testPart);
    testPart.test = this;
  }

  toStateMapInterface(): IStateMap {
    const currentItem: Item | null = this.getCurrentItem();
    const convertedTestParts: Array<ITestPart> = this.testParts
      .map((testPart) => testPart.toTestPartInterface())
      .filter((testPart) => testPart.sections && testPart.sections.length > 0);
    return {
      currentItem: currentItem ? currentItem.identifier : undefined,
      currentSection: currentItem ? currentItem.section.identifier : undefined,
      currentTestPart: currentItem ? currentItem.section.testPart.identifier : undefined,
      locationState: this._locationState,
      deliveryOptions: this.getDeliveryOptionsToSave(),
      testParts: convertedTestParts.length > 0 ? convertedTestParts : undefined,
    };
  }

  getCurrentItem(): Item | null {
    for (let i = 0; i < this._testParts.length; i++) {
      for (let j = 0; j < this._testParts[i].sections.length; j++) {
        const item: Item | undefined = this.findCurrentItemInSection(this._testParts[i].sections[j]);

        if (item) {
          return item;
        }
      }
    }
    return null;
  }

  private findCurrentItemInSection(section: Section): Item | undefined {
    for (let i = 0; i < section.subSections.length; i++) {
      const item: Item | undefined = this.findCurrentItemInSection(section.subSections[i]);
      if (item) {
        return item;
      }
    }
    return section.items.find((item) => item.currentItem);
  }

  private getCount(checkFunction: (section: Section) => number): number {
    let count = 0;
    this._testParts.forEach((testPart) => {
      testPart.sections.forEach((section) => {
        count += this.findCountInSection(section, checkFunction);
      });
    });

    return count;
  }

  private findCountInSection(section: Section, checkFunction: (section: Section) => number): number {
    let count = 0;
    section.subSections.forEach((currentSection) => {
      count += this.findCountInSection(currentSection, checkFunction);
    });

    return count + checkFunction(section);
  }
}

export default Test;
